<template>
    <div class="w-full flex flex-row justify-center gap-x-5 items-start">
        <div class="flex flex-col w-full lg:w-3/4 max-w-screen-lg"        
                v-if="!confirmSend">
            <Notice v-if="success" :notice="successNotice" :showClose="true" @close="success=false" />
             <Form title="Email All Members"
                :error="error"
                submitText="Send Email"
                @submit="goToConfirm()">
                
                <Field type="select" label="Sending Email To" 
                    :options="[{value:'members', label: 'All Members' }, {value: 'test', label: 'Test Address'}]"
                    :formValue="fv.sendingTo" />
                <Field v-if="fv.sendingTo.value == 'test'" 
                    type="text"
                    label="Test Email Recipient "
                    :formValue="fv.testEmail"
                     />
                <Field type="text"
                    label="Reply-To Address (Optional)"
                    :formValue="fv.replyTo"
                     />
                <Field type="text"
                    label="Subject"
                    :formValue="fv.subject"
                     />
                <Field type="textarea"
                    @keydown="changed = true"
                    :textControls="true"
                    label="Body"
                    class="mb-2 h-96"
                    :formValue="fv.body"
                     />                
            </Form>
        </div>      
        <div v-if="fv.body" class="flex flex-col w-full gap-y-1 max-w-screen-md mn3-content p-5 self-start rounded-sm">
            <div class="w-full flex flex-col roudned-sm border p-2">
                <Button v-if="!confirmSend" label="Update Preview" :class="changed ? 'opacity-100' : 'opacity-50'" @click="updatePreview()"/>
                <div v-if="confirmSend">Sending To: {{fv.sendingTo.value == 'members' ? 'All Members' : fv.testEmail.value}}</div>
                <div class="border-b font-mono flex flex-row justify-between w-full items-center p-1O text-xs font-mono mt-2">
                    <span @click="updatePreview">Email Preview:</span>     
                </div>
                <div v-html="emailPreview" :class="`whitespace-pre ${changed ? 'opacity-50' :'opacity-100'}`" />
            </div>
            <div v-if="confirmSend" class="flex flex-row items-center w-full">
                <Button type="submit" @click="sendEmail()" label="Send Email" class="w-3/4" />
                <Button type="cancel" @click="confirmSend = false;" label="Canel, Edit Email" class="w-1/4" />
            </div>
        </div>       
	</div>
</template>

<script>
	import Button from "@/components/Button.vue";
	import Field from "@/components/Field.vue";
	import FileUpload from "@/components/FileUpload.vue";
	import Form from "@/components/Form.vue";
	import Notice from "@/components/Notice.vue";
    import { ref } from 'vue'

	export default {
		components:{
            Button,
			Field,
            FileUpload,
			Form,
            Notice
		},
		data(){
			return {
			};
		},
        created(){
            document.title = 'Email All Members';
        },
        methods: {
            formatMessage() {
                let html = this.fv.body.value;

                // Break any direct html formatting
                html = html.replace(/</g, '&lt; ').replace(/>/g, ' &gt;');

                // Replace /n with line breaks
                html = html.replace(/\n/g, '<br>');
                
                // BBCode to HTML
                html = html
                    .replace(/\[b\](.*?)\[\/b\]/gis, '<b>$1</b>')
                    .replace(/\[alert\](.*?)\[\/alert\]/gis, '<span style="padding: 2px 4px; border-radius: 3px; background-color: #ee4444; color: white;">$1</span>')
                    .replace(/\[highlight\](.*?)\[\/highlight\]/gis, '<span style="padding: 2px 4px; border-radius: 3px; background-color: #f5f6df; border 1px solid #c3c4bc;">$1</span>')
                    .replace(/\[center\](.*?)\[\/center\]/gis, '<span style="display: block; margin: 0px auto; text-align: center">$1</span>')
                    .replace(/\[header\](.*?)\[\/header\]/gis, '<b><span style="font-size:32px">$1</span></b>')
                    .replace(/\[title\](.*?)\[\/title\]/gis, '<b><span style="font-size:24px">$1</span></b>')
                    .replace(/\[small\](.*?)\[\/small\]/gis, '<b><span style="font-size:12px">$1</span></b>')
                    .replace(/\[large\](.*?)\[\/large\]/gis, '<b><span style="font-size:24px">$1</span></b>')
                    .replace(/\[i\](.*?)\[\/i\]/gis, '<i>$1</i>')
                    .replace(/\[color=(#[0-9a-fA-F]{3,6}|[a-zA-Z]+)\](.*?)\[\/color\]/gis, '<span style="color:$1">$2</span>')
                    .replace(/\[link=([^\]]+)\](.*?)\[\/link\]/gis, '<a href="$1" target="_blank" style="padding: 2px 4px; border-radius: 3px; background-color: #eeeeff; border: 1px solid #2222ff;">$2</a>')
                    .replace(/\[size=([^\]]+)\](.*?)\[\/size\]/gis, '<span style="font-size:$1">$2</span>')
                    .replace(/\[img\](.*?)\[\/img\]/gis, '<img src="$1" style="margin: 0px auto" alt="Image" />');

                html = html
                    .replace(/&lt;(\/?(b|i|a|span|div|img)[^&]*)&gt;/g, '<$1>');

                return html
            },
            goToConfirm(){
                
                this.updatePreview();

                
                let issue = false;
                let testEmail = this.fv['testEmail'].value;
                this.error = '';

                if(this.fv.sendingTo.value == 'members')
                    testEmail = '';

                if(this.fv.sendingTo.value == 'test' && !this.isValidEmail(testEmail)){
                    issue = true
                    this.error = 'A valid test address must be entered'
                }  
                else if(this.fv['subject'].value.length == 0){
                    issue = true
                    this.error = 'An email subject must be entered'
                }
                else if(this.fv['body'].value.length == 0){
                    issue = true
                    this.error = 'An email body must be entered'
                }
                if(!issue)
                    this.confirmSend = true;
            },
            updatePreview(){
                this.emailPreview = this.formatMessage(this.fv.body.value)
                this.changed = false
            },
            /* Returns true if val has an '@' before a '.' */
            isValidEmail(val){
                if(val == undefined || val == null)
                    return false
                let indexA = val.indexOf('@')
                let indexB = val.lastIndexOf('.')
                if(indexA === -1 || indexB === -1 || indexB < indexA)
                    return false
                return true;
            }, 
            sendEmail(){
                console.log('send data: ', this.fv);
                let issue = false;
                let testEmail = this.fv['testEmail'].value;
                this.error = '';

                if(this.fv.sendingTo.value == 'members')
                    testEmail = '';

                if(this.fv.sendingTo.value == 'test' && !this.isValidEmail(testEmail)){
                    issue = true
                    this.error = 'A valid test address must be entered'
                }  
                else if(this.fv['subject'].value.length == 0){
                    issue = true
                    this.error = 'An email subject must be entered'
                }
                else if(this.fv['body'].value.length == 0){
                    issue = true
                    this.error = 'An email body must be entered'
                }

                //No issues, post the data
                if(!issue){
                    let data = {
                        data: {
                            attributes: {
                                testEmail: testEmail,
                                replyTo: this.fv['replyTo'].value,
                                subject: this.fv['subject'].value,
                                body: this.formatMessage(this.fv['body'].value),
                            }
                        }
                    }
                              
                    this.$fapi.post('email-all-members', data).then((response) =>{
                        console.log('email-all-members.response: ', response); 

                        this.success = true;
                        this.confirmSend = false
                        if(this.fv.sendingTo.value == 'members'){
                            this.successNotice = 'Email successfully sent to all members.';
                            this.fv['subject'].value = ''
                            this.fv['body'].value = ''
                        }
                        else{
                            this.successNotice = 'Test email successfully sent to ' + testEmail;
                        }


                    }).catch((error) => {                        
                        console.log('email-all-members.error: ', error);
                        this.error = error;                    
                    });
                }
            }
        },
		mounted(){

		}, 
        setup(){
            
            const showAlertOptions = ref(true)
            
			/* Form field values */
			let fv = {}
            fv['replyTo'] = ref('')
            fv['subject'] = ref('')
            fv['body'] = ref('')
            fv['testEmail'] = ref('')
            fv['sendingTo'] = ref('test')

            let error = ref('')
            let success = ref(false)
            let successNotice = ref('')
            let emailPreview = ref('')
            let confirmSend = ref(false)
            let changed = ref(false)

            return { 
                changed,
                confirmSend,
                emailPreview,
                error,
				fv,
                showAlertOptions,
                success,
                successNotice
            }

        }
	}
	
</script>
